module.exports = ".disclaimerTemplate {\n  margin-left: 5px;\n}\n"